import { Alerts } from '../../../../../../shared/types/legalProceedings/alerts';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const useAlertsProcess = (alert?: Alerts) => {
    const formik = useFormik({
        initialValues: {
            status: '',
            receptionChannel: '',
            typePQR: '',
            receivedThrough: '',
            subtypeDP: '',
            transaction: '',
            name: '',
            observation: '',
            active: true,
            newStatus: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            status: useGetNameOrValue(alert?.status || ''),
            receptionChannel: useGetNameOrValue(alert?.receptionChannel || ''),
            typePQR: useGetNameOrValue(alert?.typePQR || ''),
            receivedThrough: useGetNameOrValue(alert?.receivedThrough || ''),
            subtypeDP: useGetNameOrValue(alert?.subtypeDP || ''),
            transaction: useGetNameOrValue(alert?.transaction || ''),
            active: alert?.active || true,
            observation: alert?.observation || '',
            name: alert?.name || '',
            newStatus: useGetNameOrValue(alert?.newStatus || ''),
        });
    }, [alert]);

    return {
        formik,
    };
};
